import React, { useState } from "react";
//import { useNavigate } from "react-router-dom";

const AgentAssistPro = () => {
  //const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent page reload
    try {
      // Replace this URL with your actual Azure Function endpoint
      const response = await fetch(
        "https://phone-bot-incoming.azurewebsites.net/api/store_email?code=ul6onY6YKCnloU_O9PT65jytyMgJ4IJJATnkATfsm-hVAzFub2fCIQ==", 
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, comment }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send data to Azure Function");
      }

      // Optionally handle success (clear inputs or show a message)
      alert("Submitted successfully!");
      setEmail("");
      setComment("");
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong while submitting your data. Please try again.");
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Agent Assist Pro</h1>

      {/* Signup form */}
      <form style={styles.form} onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
          required
        />
        <br />
        <textarea
          placeholder="Enter your comment"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          style={styles.textarea}
          rows={4}
          //required
        />
        <br />
        <button type="submit" style={styles.button}>
          Submit
        </button>
      </form>
    </div>
  );
};

//<button style={styles.button} onClick={() => navigate("/")}>
//       Back to Home
//      </button>

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    textAlign: "center",
    padding: "20px",
  },
  title: {
    color: "#0078D4",
    fontSize: "2em",
    marginBottom: "20px",
  },
  text: {
    color: "#333",
    fontSize: "1em",
    marginBottom: "20px",
  },
  form: {
    marginBottom: "20px",
  },
  input: {
    padding: "8px",
    marginBottom: "10px",
    fontSize: "1em",
    width: "250px",
  },
  textarea: {
    padding: "8px",
    marginBottom: "10px",
    fontSize: "1em",
    width: "250px",
  },
  button: {
    backgroundColor: "#0078D4",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    fontSize: "1em",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "10px"
  },
};

export default AgentAssistPro;
